module.exports = __webpack_public_path__ + "static/media/224121640762869shutterstock_383952502-1.ffaa3282.jpg";